import { render, staticRenderFns } from "./StrategyPage.vue?vue&type=template&id=6181fac6&scoped=true"
import script from "./StrategyPage.vue?vue&type=script&lang=js"
export * from "./StrategyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181fac6",
  null
  
)

export default component.exports